module.exports = __webpack_public_path__ + "img/bannerLab1.53b00aeb.png";